<template>
  <v-card id="contractors" height="100%" tile>
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title class="col-6">{{
          resx.labels.contractor
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
          v-model="search"
        >
        </v-text-field>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="table-container fixed-header">
      <v-row>
        <edit-contractor
          v-model="openDialog"
          v-on:close="onClose"
          v-on:save="onSave"
        ></edit-contractor>
      </v-row>
      <v-row mr-4 class="count-items">
        <v-spacer></v-spacer>
        <v-col shrink>
          <span v-if="items.length > 0">{{
            `${
              resx.labels.countItems
            } ${resx.labels.contractor.toLowerCase()}: ${count}`
          }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col fill-height class="scrollable">
          <v-data-table
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="items"
            :search="search"
            :loading=loading
            :no-data-text="resx.messages.noContractorsAvailable"
            :no-results-text="resx.messages.noContractorsFound"
            fixed-header
            height="auto"
            sort-by="name"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            ref="dataTable"
            loading-text=""
          >
          <template v-slot:loading>
            <BarLoader :isLoading=loading />
          </template>
            <template v-slot:item.name="{ item }">
              <td class="word-wrap">
                <a @click.prevent="edit(item)">{{ item.name }}</a>
              </td>
            </template>
            <template v-slot:item.identifier="{ item }">
              <td class="hidden-xs-only word-wrap">
                {{
                  `${item.identifier.type.toUpperCase()}: ${
                    item.identifier.number
                  }`
                }}
              </td>
            </template>
            <template v-slot:item.address="{ item }">
              <td class="hidden-md-and-down dont-break-out">
                {{ buildAddress(item) }}
              </td>
            </template>
            <template v-slot:item.contactName="{ item }">
              <td class="hidden-md-and-down word-wrap">
                {{ item.contactName }}
              </td>
            </template>
            <template v-slot:item.contactPhone="{ item }">
              <td class="hidden-md-and-down dont-break-out">
                {{ item.contactPhone }}
              </td>
            </template>
            <template v-slot:item.contactEmail="{ item }">
              <td class="hidden-md-and-down dont-break-out">
                {{ item.contactEmail }}
              </td>
            </template>
            <template v-slot:item.company.name="{ item }">
              <td class="hidden-md-and-down dont-break-out">
                {{ item.company && item.company.name }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <v-menu content-class="contractor-item-menu" bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="edit(item)">
                      <v-list-item-action>
                        <v-icon color="primary">mode_edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.edit
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="remove(item)">
                      <v-list-item-action>
                        <v-icon color="error">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.delete
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            @click="create"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import { sprintf } from "sprintf-js";
import moment from "moment";

// eslint-disable-next-line
import store from "@/store/store";

import editContractor from "@/components/views/contractor/edit-contractor.view.vue";
import contractorService from "@/services/ContractorService";
import BarLoader from "@/components/common/bar-loader.vue"; 

export default {
  async mounted() {
    this.items = await contractorService.list();
    this.count = this.items.length;
    this.loading = false;
  },
  components: {
    editContractor,
    BarLoader
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      headers: [
        {
          text: resx.labels.nameOrBusinessName,
          value: "name"
        },
        {
          class: "hidden-xs-only",
          text: resx.labels.uniqueIdentifier,
          value: "identifier.number"
        },
        {
          class: "hidden-md-and-down",
          text: resx.labels.address,
          value: "address"
        },
        {
          class: "hidden-md-and-down",
          text: resx.labels.contactName,
          value: "contactName"
        },
        {
          class: "hidden-md-and-down",
          text: resx.labels.contactPhone,
          value: "contactPhone"
        },
        {
          class: "hidden-md-and-down",
          text: resx.labels.contactEmail,
          value: "contactEmail"
        },
        {
          align: "center",
          sortable: false,
          text: resx.labels.actions,
          value: "actions"
        }
      ],
      items: [],
      openDialog: null,
      hasDelayed: false,
      filterCompany: null,
      loading: true
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    create() {
      this.openDialog = {};
    },
    edit(contractor) {
      this.openDialog = {
        selectedItem: JSON.parse(JSON.stringify(contractor))
      };
    },
    buildAddress(item) {
      return `${item.address} ${item.addressNumber} ${
        item.floor ? item.floor : ""
      } ${item.office ? item.office : ""}`;
    },
    async remove(contractor) {
      await this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.contractor.toLowerCase()}`,
        content: sprintf(
          this.resx.messages.deleteContractorMessage,
          contractor.name
        )
      });
      let deleted = await contractorService.remove(contractor._id);
      const index = this.items.findIndex(
        o => o._id == contractor._id && deleted.isDeleted
      );
      this.items.splice(index, 1);
    },
    onClose() {
      this.openDialog = null;
    },
    onSave(action) {
      if (action.isNew) {
        this.items.push(action.item);
      } else {
        this.$set(
          this.items,
          this.items.findIndex(i => i._id == action.item._id),
          action.item
        );
      }
      this.onClose();
    },
    parseDate(d) {
      return moment.utc(d).format(store.state.constants.DATE_FORMAT);
    },
  },
  computed: {
    count: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = Object.keys(currentItems).length;
      return count;
    }
  },
  mixins: []
};
</script>

<style lang="scss">
.v-badge {
  display: flex;
}

#contractors {
  .comments-column {
    max-width: 270px;

    .layout.row.wrap {
      padding: 0 !important;
    }
  }
}
.contractor-item-menu {
  max-height: initial !important;
}
</style>
